/**
 * @fileoverview gRPC-Web generated client stub for suki.pb.auther
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.13.0
// source: src/auther.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.suki = {};
proto.suki.pb = {};
proto.suki.pb.auther = require('./auther_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.suki.pb.auther.AutherClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.suki.pb.auther.AutherPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.suki.pb.auther.HealthCheckRequest,
 *   !proto.suki.pb.auther.HealthCheckResponse>}
 */
const methodDescriptor_Auther_HealthCheck = new grpc.web.MethodDescriptor(
  '/suki.pb.auther.Auther/HealthCheck',
  grpc.web.MethodType.UNARY,
  proto.suki.pb.auther.HealthCheckRequest,
  proto.suki.pb.auther.HealthCheckResponse,
  /**
   * @param {!proto.suki.pb.auther.HealthCheckRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.suki.pb.auther.HealthCheckResponse.deserializeBinary
);


/**
 * @param {!proto.suki.pb.auther.HealthCheckRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.suki.pb.auther.HealthCheckResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.suki.pb.auther.HealthCheckResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.suki.pb.auther.AutherClient.prototype.healthCheck =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/suki.pb.auther.Auther/HealthCheck',
      request,
      metadata || {},
      methodDescriptor_Auther_HealthCheck,
      callback);
};


/**
 * @param {!proto.suki.pb.auther.HealthCheckRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.suki.pb.auther.HealthCheckResponse>}
 *     Promise that resolves to the response
 */
proto.suki.pb.auther.AutherPromiseClient.prototype.healthCheck =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/suki.pb.auther.Auther/HealthCheck',
      request,
      metadata || {},
      methodDescriptor_Auther_HealthCheck);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.suki.pb.auther.GetUsersRequest,
 *   !proto.suki.pb.auther.GetUsersResponse>}
 */
const methodDescriptor_Auther_GetUsers = new grpc.web.MethodDescriptor(
  '/suki.pb.auther.Auther/GetUsers',
  grpc.web.MethodType.UNARY,
  proto.suki.pb.auther.GetUsersRequest,
  proto.suki.pb.auther.GetUsersResponse,
  /**
   * @param {!proto.suki.pb.auther.GetUsersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.suki.pb.auther.GetUsersResponse.deserializeBinary
);


/**
 * @param {!proto.suki.pb.auther.GetUsersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.suki.pb.auther.GetUsersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.suki.pb.auther.GetUsersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.suki.pb.auther.AutherClient.prototype.getUsers =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/suki.pb.auther.Auther/GetUsers',
      request,
      metadata || {},
      methodDescriptor_Auther_GetUsers,
      callback);
};


/**
 * @param {!proto.suki.pb.auther.GetUsersRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.suki.pb.auther.GetUsersResponse>}
 *     Promise that resolves to the response
 */
proto.suki.pb.auther.AutherPromiseClient.prototype.getUsers =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/suki.pb.auther.Auther/GetUsers',
      request,
      metadata || {},
      methodDescriptor_Auther_GetUsers);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.suki.pb.auther.UpsertUserRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Auther_UpsertUser = new grpc.web.MethodDescriptor(
  '/suki.pb.auther.Auther/UpsertUser',
  grpc.web.MethodType.UNARY,
  proto.suki.pb.auther.UpsertUserRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.suki.pb.auther.UpsertUserRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.suki.pb.auther.UpsertUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.suki.pb.auther.AutherClient.prototype.upsertUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/suki.pb.auther.Auther/UpsertUser',
      request,
      metadata || {},
      methodDescriptor_Auther_UpsertUser,
      callback);
};


/**
 * @param {!proto.suki.pb.auther.UpsertUserRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.suki.pb.auther.AutherPromiseClient.prototype.upsertUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/suki.pb.auther.Auther/UpsertUser',
      request,
      metadata || {},
      methodDescriptor_Auther_UpsertUser);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.suki.pb.auther.DeleteUserRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Auther_DeleteUser = new grpc.web.MethodDescriptor(
  '/suki.pb.auther.Auther/DeleteUser',
  grpc.web.MethodType.UNARY,
  proto.suki.pb.auther.DeleteUserRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.suki.pb.auther.DeleteUserRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.suki.pb.auther.DeleteUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.suki.pb.auther.AutherClient.prototype.deleteUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/suki.pb.auther.Auther/DeleteUser',
      request,
      metadata || {},
      methodDescriptor_Auther_DeleteUser,
      callback);
};


/**
 * @param {!proto.suki.pb.auther.DeleteUserRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.suki.pb.auther.AutherPromiseClient.prototype.deleteUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/suki.pb.auther.Auther/DeleteUser',
      request,
      metadata || {},
      methodDescriptor_Auther_DeleteUser);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.suki.pb.auther.GetOrganizationsRequest,
 *   !proto.suki.pb.auther.GetOrganizationsResponse>}
 */
const methodDescriptor_Auther_GetOrganizations = new grpc.web.MethodDescriptor(
  '/suki.pb.auther.Auther/GetOrganizations',
  grpc.web.MethodType.UNARY,
  proto.suki.pb.auther.GetOrganizationsRequest,
  proto.suki.pb.auther.GetOrganizationsResponse,
  /**
   * @param {!proto.suki.pb.auther.GetOrganizationsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.suki.pb.auther.GetOrganizationsResponse.deserializeBinary
);


/**
 * @param {!proto.suki.pb.auther.GetOrganizationsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.suki.pb.auther.GetOrganizationsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.suki.pb.auther.GetOrganizationsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.suki.pb.auther.AutherClient.prototype.getOrganizations =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/suki.pb.auther.Auther/GetOrganizations',
      request,
      metadata || {},
      methodDescriptor_Auther_GetOrganizations,
      callback);
};


/**
 * @param {!proto.suki.pb.auther.GetOrganizationsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.suki.pb.auther.GetOrganizationsResponse>}
 *     Promise that resolves to the response
 */
proto.suki.pb.auther.AutherPromiseClient.prototype.getOrganizations =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/suki.pb.auther.Auther/GetOrganizations',
      request,
      metadata || {},
      methodDescriptor_Auther_GetOrganizations);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.suki.pb.auther.UpsertOrganizationRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Auther_UpsertOrganization = new grpc.web.MethodDescriptor(
  '/suki.pb.auther.Auther/UpsertOrganization',
  grpc.web.MethodType.UNARY,
  proto.suki.pb.auther.UpsertOrganizationRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.suki.pb.auther.UpsertOrganizationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.suki.pb.auther.UpsertOrganizationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.suki.pb.auther.AutherClient.prototype.upsertOrganization =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/suki.pb.auther.Auther/UpsertOrganization',
      request,
      metadata || {},
      methodDescriptor_Auther_UpsertOrganization,
      callback);
};


/**
 * @param {!proto.suki.pb.auther.UpsertOrganizationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.suki.pb.auther.AutherPromiseClient.prototype.upsertOrganization =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/suki.pb.auther.Auther/UpsertOrganization',
      request,
      metadata || {},
      methodDescriptor_Auther_UpsertOrganization);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.suki.pb.auther.DeleteOrganizationRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Auther_DeleteOrganization = new grpc.web.MethodDescriptor(
  '/suki.pb.auther.Auther/DeleteOrganization',
  grpc.web.MethodType.UNARY,
  proto.suki.pb.auther.DeleteOrganizationRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.suki.pb.auther.DeleteOrganizationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.suki.pb.auther.DeleteOrganizationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.suki.pb.auther.AutherClient.prototype.deleteOrganization =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/suki.pb.auther.Auther/DeleteOrganization',
      request,
      metadata || {},
      methodDescriptor_Auther_DeleteOrganization,
      callback);
};


/**
 * @param {!proto.suki.pb.auther.DeleteOrganizationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.suki.pb.auther.AutherPromiseClient.prototype.deleteOrganization =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/suki.pb.auther.Auther/DeleteOrganization',
      request,
      metadata || {},
      methodDescriptor_Auther_DeleteOrganization);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.suki.pb.auther.GetTokensRequest,
 *   !proto.suki.pb.auther.GetTokensResponse>}
 */
const methodDescriptor_Auther_GetTokens = new grpc.web.MethodDescriptor(
  '/suki.pb.auther.Auther/GetTokens',
  grpc.web.MethodType.UNARY,
  proto.suki.pb.auther.GetTokensRequest,
  proto.suki.pb.auther.GetTokensResponse,
  /**
   * @param {!proto.suki.pb.auther.GetTokensRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.suki.pb.auther.GetTokensResponse.deserializeBinary
);


/**
 * @param {!proto.suki.pb.auther.GetTokensRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.suki.pb.auther.GetTokensResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.suki.pb.auther.GetTokensResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.suki.pb.auther.AutherClient.prototype.getTokens =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/suki.pb.auther.Auther/GetTokens',
      request,
      metadata || {},
      methodDescriptor_Auther_GetTokens,
      callback);
};


/**
 * @param {!proto.suki.pb.auther.GetTokensRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.suki.pb.auther.GetTokensResponse>}
 *     Promise that resolves to the response
 */
proto.suki.pb.auther.AutherPromiseClient.prototype.getTokens =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/suki.pb.auther.Auther/GetTokens',
      request,
      metadata || {},
      methodDescriptor_Auther_GetTokens);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.suki.pb.auther.UpsertTokenMessage,
 *   !proto.suki.pb.auther.UpsertTokenMessage>}
 */
const methodDescriptor_Auther_UpsertToken = new grpc.web.MethodDescriptor(
  '/suki.pb.auther.Auther/UpsertToken',
  grpc.web.MethodType.UNARY,
  proto.suki.pb.auther.UpsertTokenMessage,
  proto.suki.pb.auther.UpsertTokenMessage,
  /**
   * @param {!proto.suki.pb.auther.UpsertTokenMessage} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.suki.pb.auther.UpsertTokenMessage.deserializeBinary
);


/**
 * @param {!proto.suki.pb.auther.UpsertTokenMessage} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.suki.pb.auther.UpsertTokenMessage)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.suki.pb.auther.UpsertTokenMessage>|undefined}
 *     The XHR Node Readable Stream
 */
proto.suki.pb.auther.AutherClient.prototype.upsertToken =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/suki.pb.auther.Auther/UpsertToken',
      request,
      metadata || {},
      methodDescriptor_Auther_UpsertToken,
      callback);
};


/**
 * @param {!proto.suki.pb.auther.UpsertTokenMessage} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.suki.pb.auther.UpsertTokenMessage>}
 *     Promise that resolves to the response
 */
proto.suki.pb.auther.AutherPromiseClient.prototype.upsertToken =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/suki.pb.auther.Auther/UpsertToken',
      request,
      metadata || {},
      methodDescriptor_Auther_UpsertToken);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.suki.pb.auther.DeactivateTokenRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Auther_DeactivateToken = new grpc.web.MethodDescriptor(
  '/suki.pb.auther.Auther/DeactivateToken',
  grpc.web.MethodType.UNARY,
  proto.suki.pb.auther.DeactivateTokenRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.suki.pb.auther.DeactivateTokenRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.suki.pb.auther.DeactivateTokenRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.suki.pb.auther.AutherClient.prototype.deactivateToken =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/suki.pb.auther.Auther/DeactivateToken',
      request,
      metadata || {},
      methodDescriptor_Auther_DeactivateToken,
      callback);
};


/**
 * @param {!proto.suki.pb.auther.DeactivateTokenRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.suki.pb.auther.AutherPromiseClient.prototype.deactivateToken =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/suki.pb.auther.Auther/DeactivateToken',
      request,
      metadata || {},
      methodDescriptor_Auther_DeactivateToken);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.suki.pb.auther.ValidateTokenRequest,
 *   !proto.suki.pb.auther.ValidateTokenResponse>}
 */
const methodDescriptor_Auther_ValidateToken = new grpc.web.MethodDescriptor(
  '/suki.pb.auther.Auther/ValidateToken',
  grpc.web.MethodType.UNARY,
  proto.suki.pb.auther.ValidateTokenRequest,
  proto.suki.pb.auther.ValidateTokenResponse,
  /**
   * @param {!proto.suki.pb.auther.ValidateTokenRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.suki.pb.auther.ValidateTokenResponse.deserializeBinary
);


/**
 * @param {!proto.suki.pb.auther.ValidateTokenRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.suki.pb.auther.ValidateTokenResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.suki.pb.auther.ValidateTokenResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.suki.pb.auther.AutherClient.prototype.validateToken =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/suki.pb.auther.Auther/ValidateToken',
      request,
      metadata || {},
      methodDescriptor_Auther_ValidateToken,
      callback);
};


/**
 * @param {!proto.suki.pb.auther.ValidateTokenRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.suki.pb.auther.ValidateTokenResponse>}
 *     Promise that resolves to the response
 */
proto.suki.pb.auther.AutherPromiseClient.prototype.validateToken =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/suki.pb.auther.Auther/ValidateToken',
      request,
      metadata || {},
      methodDescriptor_Auther_ValidateToken);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.suki.pb.auther.MetricsRequest,
 *   !proto.suki.pb.auther.MetricsResponse>}
 */
const methodDescriptor_Auther_UptimeMetrics = new grpc.web.MethodDescriptor(
  '/suki.pb.auther.Auther/UptimeMetrics',
  grpc.web.MethodType.UNARY,
  proto.suki.pb.auther.MetricsRequest,
  proto.suki.pb.auther.MetricsResponse,
  /**
   * @param {!proto.suki.pb.auther.MetricsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.suki.pb.auther.MetricsResponse.deserializeBinary
);


/**
 * @param {!proto.suki.pb.auther.MetricsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.suki.pb.auther.MetricsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.suki.pb.auther.MetricsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.suki.pb.auther.AutherClient.prototype.uptimeMetrics =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/suki.pb.auther.Auther/UptimeMetrics',
      request,
      metadata || {},
      methodDescriptor_Auther_UptimeMetrics,
      callback);
};


/**
 * @param {!proto.suki.pb.auther.MetricsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.suki.pb.auther.MetricsResponse>}
 *     Promise that resolves to the response
 */
proto.suki.pb.auther.AutherPromiseClient.prototype.uptimeMetrics =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/suki.pb.auther.Auther/UptimeMetrics',
      request,
      metadata || {},
      methodDescriptor_Auther_UptimeMetrics);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.suki.pb.auther.MetricsRequest,
 *   !proto.suki.pb.auther.MetricsResponse>}
 */
const methodDescriptor_Auther_LatencyMetrics = new grpc.web.MethodDescriptor(
  '/suki.pb.auther.Auther/LatencyMetrics',
  grpc.web.MethodType.UNARY,
  proto.suki.pb.auther.MetricsRequest,
  proto.suki.pb.auther.MetricsResponse,
  /**
   * @param {!proto.suki.pb.auther.MetricsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.suki.pb.auther.MetricsResponse.deserializeBinary
);


/**
 * @param {!proto.suki.pb.auther.MetricsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.suki.pb.auther.MetricsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.suki.pb.auther.MetricsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.suki.pb.auther.AutherClient.prototype.latencyMetrics =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/suki.pb.auther.Auther/LatencyMetrics',
      request,
      metadata || {},
      methodDescriptor_Auther_LatencyMetrics,
      callback);
};


/**
 * @param {!proto.suki.pb.auther.MetricsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.suki.pb.auther.MetricsResponse>}
 *     Promise that resolves to the response
 */
proto.suki.pb.auther.AutherPromiseClient.prototype.latencyMetrics =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/suki.pb.auther.Auther/LatencyMetrics',
      request,
      metadata || {},
      methodDescriptor_Auther_LatencyMetrics);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.suki.pb.auther.CreateAPIKeyRequest,
 *   !proto.suki.pb.auther.CreateAPIKeyResponse>}
 */
const methodDescriptor_Auther_CreateAPIKey = new grpc.web.MethodDescriptor(
  '/suki.pb.auther.Auther/CreateAPIKey',
  grpc.web.MethodType.UNARY,
  proto.suki.pb.auther.CreateAPIKeyRequest,
  proto.suki.pb.auther.CreateAPIKeyResponse,
  /**
   * @param {!proto.suki.pb.auther.CreateAPIKeyRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.suki.pb.auther.CreateAPIKeyResponse.deserializeBinary
);


/**
 * @param {!proto.suki.pb.auther.CreateAPIKeyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.suki.pb.auther.CreateAPIKeyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.suki.pb.auther.CreateAPIKeyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.suki.pb.auther.AutherClient.prototype.createAPIKey =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/suki.pb.auther.Auther/CreateAPIKey',
      request,
      metadata || {},
      methodDescriptor_Auther_CreateAPIKey,
      callback);
};


/**
 * @param {!proto.suki.pb.auther.CreateAPIKeyRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.suki.pb.auther.CreateAPIKeyResponse>}
 *     Promise that resolves to the response
 */
proto.suki.pb.auther.AutherPromiseClient.prototype.createAPIKey =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/suki.pb.auther.Auther/CreateAPIKey',
      request,
      metadata || {},
      methodDescriptor_Auther_CreateAPIKey);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.suki.pb.auther.GetAPIKeysResponse>}
 */
const methodDescriptor_Auther_GetAPIKeys = new grpc.web.MethodDescriptor(
  '/suki.pb.auther.Auther/GetAPIKeys',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.suki.pb.auther.GetAPIKeysResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.suki.pb.auther.GetAPIKeysResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.suki.pb.auther.GetAPIKeysResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.suki.pb.auther.GetAPIKeysResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.suki.pb.auther.AutherClient.prototype.getAPIKeys =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/suki.pb.auther.Auther/GetAPIKeys',
      request,
      metadata || {},
      methodDescriptor_Auther_GetAPIKeys,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.suki.pb.auther.GetAPIKeysResponse>}
 *     Promise that resolves to the response
 */
proto.suki.pb.auther.AutherPromiseClient.prototype.getAPIKeys =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/suki.pb.auther.Auther/GetAPIKeys',
      request,
      metadata || {},
      methodDescriptor_Auther_GetAPIKeys);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.suki.pb.auther.DeleteAPIKeyRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Auther_DeleteAPIKey = new grpc.web.MethodDescriptor(
  '/suki.pb.auther.Auther/DeleteAPIKey',
  grpc.web.MethodType.UNARY,
  proto.suki.pb.auther.DeleteAPIKeyRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.suki.pb.auther.DeleteAPIKeyRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.suki.pb.auther.DeleteAPIKeyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.suki.pb.auther.AutherClient.prototype.deleteAPIKey =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/suki.pb.auther.Auther/DeleteAPIKey',
      request,
      metadata || {},
      methodDescriptor_Auther_DeleteAPIKey,
      callback);
};


/**
 * @param {!proto.suki.pb.auther.DeleteAPIKeyRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.suki.pb.auther.AutherPromiseClient.prototype.deleteAPIKey =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/suki.pb.auther.Auther/DeleteAPIKey',
      request,
      metadata || {},
      methodDescriptor_Auther_DeleteAPIKey);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.suki.pb.auther.CreateSessionTokenRequest,
 *   !proto.suki.pb.auther.CreateSessionTokenResponse>}
 */
const methodDescriptor_Auther_CreateSessionToken = new grpc.web.MethodDescriptor(
  '/suki.pb.auther.Auther/CreateSessionToken',
  grpc.web.MethodType.UNARY,
  proto.suki.pb.auther.CreateSessionTokenRequest,
  proto.suki.pb.auther.CreateSessionTokenResponse,
  /**
   * @param {!proto.suki.pb.auther.CreateSessionTokenRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.suki.pb.auther.CreateSessionTokenResponse.deserializeBinary
);


/**
 * @param {!proto.suki.pb.auther.CreateSessionTokenRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.suki.pb.auther.CreateSessionTokenResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.suki.pb.auther.CreateSessionTokenResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.suki.pb.auther.AutherClient.prototype.createSessionToken =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/suki.pb.auther.Auther/CreateSessionToken',
      request,
      metadata || {},
      methodDescriptor_Auther_CreateSessionToken,
      callback);
};


/**
 * @param {!proto.suki.pb.auther.CreateSessionTokenRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.suki.pb.auther.CreateSessionTokenResponse>}
 *     Promise that resolves to the response
 */
proto.suki.pb.auther.AutherPromiseClient.prototype.createSessionToken =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/suki.pb.auther.Auther/CreateSessionToken',
      request,
      metadata || {},
      methodDescriptor_Auther_CreateSessionToken);
};


module.exports = proto.suki.pb.auther;

